import React from 'react';
import {
  Container,
  Row,
  Col,
  ProgressBar,
  Alert,
} from 'react-bootstrap';
import {
  useIndex,
  useProgress,
} from '@hooks';
import ProgressBarHeader from "@/ProgressBarHeader";
import Step1 from './Step1';
import Step2 from './Step2';
import CompletedApplication from './CompletedApplication';
import {
  useSelector
} from 'react-redux';
import {
  isPresent
} from '@utils';

import SwipeableViews from 'react-swipeable-views';


export const headerSteps = [
  {
    value: "Step 1",
    className: "progress-bar-header-step",
    subheader: {
      value: "Basic Info",
      className: "progress-bar-sub-header-step"
    }
  },
  {
    value: "Step 2",
    className: "progress-bar-header-step",
    subheader: {
      value: "About You",
      className: "progress-bar-sub-header-step"
    }
  }
];

const ProgressBarContainer = ({currentIndex, progress}) => {
  return (
    <>
      <ProgressBarHeader
        className="justify-content-around"
        steps={headerSteps}
        currentIndex={currentIndex}
      />
      <ProgressBar now={progress} />
    </>
  )
}

const FormContainer = ({ children, currentIndex, progress, }) => {
  return (
    <div className="form">
      <div className="title">
        <h1><i className="fas fa-female"></i>Model Sign Up</h1>
        <p>Nudiez accepts a limited number of applications for models. If you are remarkably attractive, self motivated, and have a strong work ethic, we would love to speak with you. Please note this is adult.</p>
      </div>
      <div className="form-container">
        <ProgressBarContainer currentIndex={currentIndex} progress={progress}/>
        {children}
      </div>
    </div>
  )
}

const initialProgress = 50;
const endingProgress = 100;

const InfluencerApplication = () => {
  const { currentIndex, setCurrentIndex } = useIndex();
  let { progress, setProgress } = useProgress(initialProgress);

  const goToNextStep = () => {
    if (progress < endingProgress) {
      setProgress(progress += progress);
    }
    setCurrentIndex(currentIndex + 1);
  }

  const influencerApplication = useSelector(state => {
    return state.influencerApplication
  });

  const goToPreviousStep = () => {
    const nextIndex = currentIndex - 1;
    if (nextIndex >= 0) {
      setProgress(progress -= progress);
      setCurrentIndex(currentIndex - 1);
    }
  }

  return (
    <div className='apply-container'>
      <Container>
        <Row className='justify-content-center apply-row'>
          <div className='top'>
            <div className="overlay"></div>
          </div>
          {
            isPresent(influencerApplication.serverError)  ?
            <Col sm={12}>
              <Alert variant={'warning'}>{
                Array.isArray(influencerApplication.serverError) ?
                <ul>
                  {
                  influencerApplication.serverError.map((error) => {
                    return <li>{error}</li>
                  })}
                </ul> : influencerApplication.serverError
              }</Alert>
            </Col>: null
          }
          <Col sm={12}>
            <SwipeableViews
              enableMouseEvents
              disabled={true}
              index={currentIndex}
              onChangeIndex={e => setCurrentIndex(e)}
            >
               <FormContainer currentIndex={currentIndex} progress={progress}>
                <Step1 goToNextStep={goToNextStep} />
              </FormContainer>
              <FormContainer currentIndex={currentIndex} progress={progress}>
                <Step2 goToNextStep={goToNextStep} goToPreviousStep={goToPreviousStep} />
              </FormContainer>
              <CompletedApplication />
            </SwipeableViews>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default InfluencerApplication;